export function Tabs({ value, onChange, tabs }) {
  return (
    <div className="flex flex-wrap gap-2 border-b border-tertiary -mt-2">
      {tabs.map((t) => (
        <button
          key={t.value}
          type="button"
          onClick={() => onChange(t.value)}
          data-testid={`tab-${t.value}`}
          className={`px-4 py-2.5 text-sm font-semibold transition-colors -mb-px ${
            value === t.value
              ? "text-brand-500 border-b-2 border-brand-500"
              : "text-ink-500 hover:text-ink-900 border-b-2 border-transparent"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
